import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// Services
import { EventsService } from '../../services/events.service';
import { BookingService } from '../../services/booking.service';
import { PriceService } from '../../services/price.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { BagItemsService } from '../../../shared/services/bagItems.service';

@Component({
  selector: 'app-d2d-booking-switch',
  templateUrl: './d2d-booking-switch.component.html',
  styleUrls: ['./d2d-booking-switch.component.scss']
})
export class D2dBookingSwitchComponent implements OnInit, OnDestroy {
  private _routeParamsSubscription: Subscription;
  private _priceUpdateSubscription: Subscription;
  private currentPanel;


  constructor(
    private _appStore: Store<AppState>,
    private _appLoaderService: AppLoaderService,
    private _appStateService: AppStateService,
    private _eventsService: EventsService,
    private _dataStorageService: DataStorageService,
    private _bookingService: BookingService,
    private _bagItemsService: BagItemsService,
    private _pricingService: PriceService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._priceUpdateSubscription = this._pricingService.priceUpdating$
      .subscribe(isUpdating => {
        if (!isUpdating) {
          setTimeout(() => {
            this.switchState();
          });
        }
      });

    const state = this.getState(this._appStore);
    const promoCode = state.bookingReducer.bookingDetails.promo;
    if (promoCode.length > 0 && state.d2dReducer.addBookingCount === 0 && state.updatePanelReducer === 3) {
      this._pricingService.removeSetPromo(promoCode[0], true);
    } else {
      this.switchState();
    }
  }

  switchState() {
    // subscribe to router query string
    const params = this._activatedRoute.snapshot.queryParams;


        if (typeof params.redirectToPath !== 'undefined') {
          let url;
          // if user removed service
          const searchParams = params.data ? JSON.parse(params.data) : {};
          if (searchParams?.serviceToRemove) {
            if (searchParams.serviceToRemove === 'abc') {
              url = '/ccd/payment';
              this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
            }

            if (searchParams.serviceToRemove === 'ccd') {
              url = '/abc/payment';
              this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
            }

            // get d2d state and set all reducers
            const state = this.getState(this._appStore);
            this._bookingService.updateD2dstate();
            if (params.bookingProduct === 'abc') {
              this._appStateService.setBookingStores(state.d2dReducer.outboundBooking);
            } else {
              this._appStateService.setBookingStores(state.d2dReducer.inboundBooking);
            }
            const departureAirportCode = state.d2dReducer.outboundBooking.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].departureAirport.airportCode;
            const carrier = state.d2dReducer.outboundBooking.bookingReducer.bookingDetails.carrier;
            const airlineCode = carrier.airlineCode === 'LX' && carrier.operatingCode === 'LX' ? 'LX' : 'None';
            const isHubdropBooking = state.d2dReducer.outboundBooking.hubDropReducer.selectedPostOffice !== null && state.d2dReducer.outboundBooking.hubDropReducer.selectedCollectionType === 'atPostOffice';
            this._eventsService.generatePaths(params.bookingProduct, departureAirportCode, isHubdropBooking, airlineCode);
            this._eventsService.goToPanelByPath(params.redirectToPath);
            this.currentPanel = this._eventsService.getUrlIndex(params.redirectToPath) + 1;
            setTimeout(() => {
              this._router.navigate([this._eventsService.getURLPath(this.currentPanel, params.bookingProduct)], {
                replaceUrl: true, queryParams: { d2d: 'falseD2D' }
              });
              this._dataStorageService.saveData();
            }, 500);
            return;
          }
          // get d2d state and set all reducers
          const state = this.getState(this._appStore);
          this._bookingService.updateD2dstate();
          if (params.bookingProduct === 'abc') {
            this._appStateService.setBookingStores(state.d2dReducer.outboundBooking);
          } else {
            this._appStateService.setBookingStores(state.d2dReducer.inboundBooking);
          }

          // update the panel reducer if needed
          const carrier = state.d2dReducer.outboundBooking.bookingReducer.bookingDetails.carrier;
          const airlineCode = carrier.airlineCode === 'LX' && carrier.operatingCode === 'LX' ? 'LX' : 'None';
          const departureAirportCode = state.d2dReducer.outboundBooking.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].departureAirport.airportCode;
          const isHubdropBooking = state.d2dReducer.outboundBooking.hubDropReducer.selectedPostOffice !== null && state.d2dReducer.outboundBooking.hubDropReducer.selectedCollectionType === 'atPostOffice';
          this._eventsService.generatePaths(params.bookingProduct, departureAirportCode, isHubdropBooking, airlineCode);
          this._eventsService.goToPanelByPath(params.redirectToPath);
          this.currentPanel = this._eventsService.getUrlIndex(params.redirectToPath) + 1;


          // switch to other booking
          setTimeout(() => {
            const state = this.getState(this._appStore);
            const flightProducts = state.d2dReducer.flightDetails.flightProducts;
            let queryParams = {};
            if (params.data !== 'null') { queryParams = { bags: params.data }; }
            if (params.d2d !== 'null' && params.d2d === 'falseD2D') { queryParams = { d2d: params.d2d }; }

            if (state.bookingReducer.bookingDetails.isD2dService && !(flightProducts.abc && flightProducts.ccd)) {
              this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
            }
            this._router.navigate([this._eventsService.getURLPath(this.currentPanel, params.bookingProduct)], {
              replaceUrl: true,
              queryParams: queryParams
            });

            this._dataStorageService.saveData();
          }, 500);

          // remove this timeout and move this code to payment container
          // setTimeout(() => {
          //   if (params.data) {
          //     const bagItems = JSON.parse(params.data);
          //     this._appStateService.setBagItems({ ...bagItems });
          //     this._bookingService.updateBagItems({ ...bagItems });

          //     const totalBags = this._bagItemsService.getTotalItems(bagItems);
          //     this._appStateService.setVirtualBags(totalBags);
          //     this._bookingService.updateVirtualBags(totalBags);
          //   }
          // }, 1500);

        }
  }

  // get store state
  getState(store: Store<AppState>) {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    if (this._priceUpdateSubscription) { this._priceUpdateSubscription.unsubscribe(); }
  }
}
